import * as THREE from 'three';

export default class Utils {
    /**
    * Generates a random float between min and max.
    */


    static fnAddModelToRegistry(modelRegistry, name, mesh, position, lqTexture, isAddedToScene, needsTextureSwapToHQ, distanceTextureSwap, textureIsLoaded, bvh, collisionRadius) {
        const modelID = Symbol(name); // Ensures uniqueness
        modelRegistry.set(modelID, {
            name,
            mesh,
            needsTextureSwapToHQ,
            distanceTextureSwap,
            textureIsLoaded, //boolean  flag avoiding multiple downloads
            isAddedToScene,
            position, // Store position for fast access
            bvh, // BVH data for fast collision checks
            collisionRadius,
            lastDistance: Infinity, // Store last distance for optimizations
            hqTexture: null, //Store HQ texture reference
            lqTexture //Store reference to lof-fi texture
        });
        return modelID;
    }

    /**
    * Generates a random position that is outside of the borderSize
    */
    static fnGetRandomPosition(borderSize, rangeX, rangeZ) {
        let x, z;
        //const borderSize = 500; // The excluded zone

        // Randomly decide if we place the object in X or Z direction
        if (Math.random() < 0.5) {
            // Place on left (-x) or right (+x)
            x = (Math.random() < 0.5 ? -1 : 1) * (borderSize + Math.random() * borderSize);
            z = Math.random() * rangeZ - (rangeZ / 2); // Fully random Z range
        } else {
            // Place on top (+z) or bottom (-z)
            z = (Math.random() < 0.5 ? -1 : 1) * (borderSize + Math.random() * borderSize);
            x = Math.random() * rangeX - (rangeX / 2); // Fully random X range
        }

        return { x, z };
    }



    /**
     * Generates a random float between min and max.
     */
    static randomFloat(min, max) {
        return Math.random() * (max - min) + min;
    }

    /**
     * Generates a random integer between min and max.
     */
    static randomInt(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    /**
     * Clamps a value between min and max.
     */
    static clamp(value, min, max) {
        return Math.max(min, Math.min(max, value));
    }

    /**
     * Linearly interpolates between two values.
     */
    static lerp(start, end, t) {
        return start * (1 - t) + end * t;
    }

    /**
     * Checks if an object is within a certain distance from a point.
     */
    static fnIsWithinDistance(objPosition, targetPosition, distance) {
        return objPosition.distanceTo(targetPosition) <= distance;

    }

    /**
     * Checks if an object is within the camera frustum.
     */
    static fnIsInFrustum(object, camera) {
        const frustum = new THREE.Frustum();
        const cameraViewProjectionMatrix = new THREE.Matrix4();
        camera.updateMatrixWorld();
        camera.updateProjectionMatrix();
        cameraViewProjectionMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
        frustum.setFromProjectionMatrix(cameraViewProjectionMatrix);
        return frustum.intersectsObject(object);
    }

    /**
     * Converts degrees to radians.
     */
    static degToRad(degrees) {
        return degrees * (Math.PI / 180);
    }

    /**
     * Converts radians to degrees.
     */
    static radToDeg(radians) {
        return radians * (180 / Math.PI);
    }
}